import { BehaviorSubject } from 'rxjs';

const NationalityLabelSubject = new BehaviorSubject(process.env.nationalityLabel);

export const NationalityLabelStore = {
  update: value => {
    NationalityLabelSubject.next(value);
  },
  subscribe: setState => NationalityLabelSubject.subscribe(setState),
  getValue: () => NationalityLabelSubject.value,
};

export default { NationalityLabelStore };
